<template lang="pug">
div.wrap-scene-settings.px12.pt12.pb10
  div.toggle-tone-pass
    span.label.block.fz16.mb10.mr12 カラーモード
    v-switch(v-model="enableColor"
      :label="enableColor ? 'カラー' : 'モノトーン'" dark)
  div.bg-color-picker.mb14
    span.label.block.fz16.mb12.mr12 背景色
    div.f.fm
      div(v-for="item in sceneBackgroundColors"
        @click="updateSceneBackgroundColor(item.value)"
        :style="`background: ${item.styleColor};`"
        :class="{'active': sceneBacckgroundColor == item.value}").pallete.mr6.cursor-pointer
  AtomSliderWithInput(v-model="ambientLightIntensity"
    :defaultValue="defaultAmbientLightIntensity"
    label="明るさ" :min="0" :max="20" :step="0.1" disableMinus dark)
  AtomRangeSliderWithInput(v-model="comicalShaderThreholdValue"
    :defaultValue="defaultComicalShaderThreholdValue"
    label="色調" :min="0.0" :max="1.0" :step="0.01" dark)
  AtomSliderWithInput(v-model="cameraFovValue"
    :defaultValue="defaultCameraFov"
    label="画角" :min="1" :max="200" :step="1" dark)
  AtomRangeSliderWithInput(v-model="cameraNearFarValue"
    :defaultValue="defaultCameraNearFar"
    label="描画範囲（遠近）" :min="0.1" :max="140" :step="0.1" dark)
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$pallete_size: 32px;
.wrap-scene-settings {
  color: $dark_primary_text_color;
  width: 80vw; height: 100%;
  max-width: $studio_window_max_width; max-height: 80vh;
  overflow: scroll;
  .wrap-scene-settings {
    border-bottom: solid 0.8px rgba(240, 221, 221, 0.4); 
  }
  .bg-color-picker {
    .pallete {
      width: $pallete_size; height: $pallete_size;
      border-radius: 50%;
      border: solid 1px rgba(255, 255, 255, 0.6);
      &.active {
        border: solid $active_color 1px;
      }
    }
  }
  .v-input--selection-controls {
    margin-top: 0;
  }
}
</style>

<script>
import * as THREE from 'three'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import studioManager from '@/components/mixin/studioManager'
import AtomSliderWithInput from '@/components/atom/studio/AtomSliderWithInput'
import AtomRangeSliderWithInput from '@/components/atom/studio/AtomRangeSliderWithInput'

export default {
  mixins: [studioManager],
  components: {
    AtomSliderWithInput, AtomRangeSliderWithInput
  },
  props: {
    scene: {
      type: Object,
      required: true
    },
    frame: {
      type: Object,
      required: true
    },
    ambientLight: {
      type: Object,
      required: true
    },
    cameraFov: {
      type: Number,
      required: true
    },
    cameraNearFar: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      enableColor: false,
      ambientLightIntensity: this.defaultAmbientIntensity,
      sceneBacckgroundColor: null,
      sceneBackgroundColors: [
        { styleColor: 'rgba(0, 0, 0, 0.0)', value: null },
        { styleColor: '#ffffff', value: 0xffffff },
        { styleColor: '#b2b2b2', value: 0xb2b2b2 },
        { styleColor: '#000000', value: 0x000000 }
      ],
      comicalShaderThreholdValue: [],
      sliderComicalShaderThreholdValue: [],
      cameraFovValue: null,
      cameraNearFarValue: []
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  watch: {
    enableColor () {
      this.$emit('toggleTonePass', this.enableColor)
    },
    ambientLightIntensity () {
      this.$emit('updateAmbientLightIntensity', this.ambientLightIntensity)
    },
    comicalShaderThreholdValue () {
      this.$emit('updateComicalConvertPassThrehold', { 
        x: this.comicalShaderThreholdValue[1],
        y: this.comicalShaderThreholdValue[0]
      })
    },
    cameraFovValue () {
      this.$emit('updateCameraFov', this.cameraFovValue)
    },
    cameraNearFarValue () {
      this.$emit('updateCameraNearFar', this.cameraNearFarValue)
    }
  },
  created () {
    const enableColorInStudio = localStorage.getItem('enableColorInStudio')
    if (enableColorInStudio && enableColorInStudio === 'color') {
      this.enableColor = enableColorInStudio
    }

    this.ambientLightIntensity = this.ambientLight.intensity
    this.sceneBacckgroundColor = this.scene.background ? this.scene.background : null
    this.cameraFovValue = this.cameraFov
    this.cameraNearFarValue = this.cameraNearFar

    // this.comicalShaderThreholdValue = (this.frame.scene && this.frame.scene.comicalShaderThrehold) ?
    //   this.frame.scene.comicalShaderThrehold : { x: 0.77059, y: 0.40000 } // [0.75, 0.89]
    this.comicalShaderThreholdValue = (this.frame.scene && this.frame.scene.comicalShaderThrehold) ?
      this.frame.scene.comicalShaderThrehold
      : [0.77059, 0.40000]
  },
  methods: {
    updateSceneBackgroundColor (color) {
      this.sceneBacckgroundColor = color
      const threeColor = (color !== null) ? new THREE.Color(color) : null
      this.$emit('updateSceneBackgroundColor', threeColor)
    }
  }
}
</script>
